module.exports = __webpack_public_path__ + "img/Iphone.d182a49f.svg";